module.exports = __webpack_public_path__ + "static/media/5.9d0549c1.svg";